{
  "slug": "daily-brain-challenge",
  "title": "Daily Brain Challenge",
  "description": "Rotate reasoning, memory, language, and calculation.",
  "category": "Brain training",
  "sections": [
    {
      "heading": "What to train",
      "paragraphs": [
        "Rotate reasoning, memory, language, and calculation.",
        "Specific practice transfers most strongly to similar tasks; broad-transfer claims need caution."
      ]
    },
    {
      "heading": "Exercises",
      "paragraphs": ["Increase difficulty only when accuracy is stable."],
      "bullets": [
        "Monday: sequence",
        "Tuesday: recall",
        "Wednesday: rotation",
        "Thursday: analogy",
        "Friday: logic grid",
        "Weekend: error review"
      ]
    },
    {
      "heading": "Sustainable routine",
      "paragraphs": [
        "Use brief regular sessions, adequate sleep, movement, and recovery.",
        "Track accuracy and difficulty rather than expecting a guaranteed IQ increase."
      ]
    }
  ],
  "related": ["can-iq-change-over-time", "working-memory-explained", "processing-speed-explained"],
  "sources": [],
  "faqs": [],
  "summary": "Rotate reasoning, memory, language, and calculation. Content reviewed 18 July 2026."
}
